export default __webpack_public_path__ + "static/media/firetrap.2f0bc50e.png";